import { getFloorSuggestions } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";

/**
 * The areas the tab lists on the selected floor, and the ones with places free that it suggests on the floors next to
 * it, most available first. It's loading until the first sensor data arrives; refreshes keep the older data.
 */
export const useWorkspacesModel = () => {
  const { isTabLoading, filterData } = useRequiredContext(HaNContext);

  return {
    isLoading: isTabLoading,

    areas: filterData.workspaces.filteredData,

    suggestions: getFloorSuggestions(filterData.workspaces.adjacentFilteredData),
  };
};
